







































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MainButton from '@/main-components/common/MainButton.vue';
import Modal from '@/main-components/common/modal/Modal.vue';
import Input from '../common/Input.vue';
import GeneratedQuestionContainer from '@/main-components/question-generated/GeneratedQuestionContainer.vue';
import {
  PreCollection,
  PreCollectionThumbnail,
  PreCollectionType,
  preCollectionThumbnailList,
  preCollectionTypeList,
} from '@/resource/pre-collection/pre-collection.model';
import { axios } from '@/utils/axios';
import { PaperGenerated } from '@/resource/paper-generated/paper-generated.model';

async function createPreCollection(params: {
  name: string;
  description: string; // 30
  details: string; // 80
  type: PreCollectionType;
  thumbnail: PreCollectionThumbnail;
  form: number;
  year: number;
  subjectUuid: string;
  paperGeneratedId: number;
}): Promise<PreCollection> {
  const { data } = await axios.post('pre-collections', {
    ...params,
    isDraft: false,
    isPremium: false,
  });

  return data;
}

@Component({
  components: {
    MainButton,
    Modal,
    Input,
    GeneratedQuestionContainer,
  },
})
export default class ModalCreatePreCollection extends Vue {
  @Prop({ required: true })
  paperGenerated: PaperGenerated;

  isLoading = false;
  openModal: any = null;
  closeModal: any = null;

  nameInput = '';
  descriptionInput = '';
  detailsInput = '';
  typeInput = PreCollectionType.Exam;
  thumbnailInput = PreCollectionThumbnail.PERCUBAAN;
  yearInput = 2021;

  get preCollectionTypes(): PreCollectionType[] {
    return preCollectionTypeList;
  }

  get preCollectionThumbnails(): PreCollectionThumbnail[] {
    return [...preCollectionThumbnailList];
  }

  mounted() {
    this.$emit('openModalCreatePreCollectionAdd', () => {
      this.openModal && this.openModal();
    });
  }

  @Watch('paperGenerated')
  onPaperGeneratedChanged() {
    if (this.paperGenerated) {
      this.nameInput = this.paperGenerated.name;
    }
  }

  openModalAdd(openModal: any) {
    this.openModal = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModal = closeModal;
  }

  async createPreCollectionClick() {
    this.isLoading = true;

    await createPreCollection({
      name: this.nameInput,
      description: this.descriptionInput,
      details: this.detailsInput,
      type: this.typeInput,
      thumbnail: this.thumbnailInput,
      year: this.yearInput,
      form: this.paperGenerated.form,
      subjectUuid: this.paperGenerated.subject.uuid,
      paperGeneratedId: this.paperGenerated.id,
    });

    this.$router.go(0);

    this.isLoading = false;
  }
}
